import styled from '@emotion/styled';

export const ChecklistCard = styled.div`
    border: 1px solid rgba(148, 163, 184, 0.22);
    border-radius: 16px;
    background: rgba(255, 255, 255, 0.82);
    box-shadow: 0 1px 0 rgba(255, 255, 255, 0.85);
    overflow: hidden;
`;

export const ChecklistHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    padding: 12px 16px;
    border-bottom: 1px solid rgba(148, 163, 184, 0.16);
`;

export const ChecklistTitle = styled.span`
    color: #111827;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.02em;
`;

export const ChecklistCount = styled.span`
    margin-left: 6px;
    color: #94a3b8;
    font-size: 13px;
    font-weight: 600;
`;

export const SelectAllButton = styled.button`
    border: none;
    background: transparent;
    color: #6d41d8;
    font-size: 13px;
    font-weight: 700;
    cursor: pointer;
    padding: 4px 8px;
    border-radius: 8px;
    transition: background 0.2s ease;

    &:hover:not(:disabled) {
        background: rgba(131, 83, 226, 0.08);
    }

    &:disabled {
        color: #cbd5e1;
        cursor: not-allowed;
    }
`;

export const ChecklistList = styled.div`
    display: flex;
    flex-direction: column;
    max-height: 280px;
    overflow-y: auto;

    scrollbar-width: thin;
    scrollbar-color: rgba(148, 163, 184, 0.45) transparent;

    &::-webkit-scrollbar {
        width: 8px;
    }

    &::-webkit-scrollbar-thumb {
        background-color: rgba(148, 163, 184, 0.45);
        border-radius: 999px;
        border: 2px solid transparent;
        background-clip: padding-box;
    }
`;

export const ChecklistRow = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 6px 16px 6px 8px;

    &:not(:last-of-type) {
        border-bottom: 1px solid rgba(148, 163, 184, 0.12);
    }

    &:hover {
        background: rgba(131, 83, 226, 0.04);
    }
`;

export const DocNameWrap = styled.div<{ disabled?: boolean }>`
    flex: 1 1 auto;
    min-width: 0;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    cursor: ${({ disabled }) => (disabled ? 'default' : 'pointer')};
`;

export const DocName = styled.span<{ muted?: boolean }>`
    color: ${({ muted }) => (muted ? '#94a3b8' : '#111827')};
    font-size: 14px;
    font-weight: 500;
    line-height: 1.4;
`;

const Badge = styled.span`
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    padding: 2px 8px;
    border-radius: 999px;
    font-size: 11px;
    font-weight: 700;
    letter-spacing: 0.02em;
`;

export const FormBadge = styled(Badge)`
    background: rgba(131, 83, 226, 0.1);
    color: #6d41d8;
`;

export const AddedBadge = styled(Badge)`
    background: rgba(34, 197, 94, 0.12);
    color: #15803d;
`;

export const InfoWrap = styled.span`
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    cursor: pointer;
`;

export const ChecklistMessage = styled.div`
    padding: 18px 16px;
    color: #64748b;
    font-size: 13px;
    font-style: italic;
    text-align: center;
`;

export const CreatedList = styled.ul`
    margin: 4px 0 0;
    padding-left: 18px;
    color: #15803d;
    font-size: 13px;
    line-height: 1.6;
`;
